<!--
 * @Description: 模板单项组件
 * @Autor: WangYuan
 * @Date: 2021-05-31 11:55:13
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-01-27 19:43:23
-->
<template>
  <el-tooltip class="item" effect="light" :content="label" placement="bottom" :open-delay="200" :disabled="label == ''">
    <img class="mode-select-item flex-center" :class="[value == mode.mValue ? 'mode-select-item-active' : '']" :src="img" @click="clickItem">
    </img>
  </el-tooltip>
</template>

<script>
export default {
  name: 'search-item',

  props: ['label', 'value', 'icon', 'range','img'],

  inject: ['mode'],

  methods: {
    clickItem() {
      this.mode.mValue = this.value
      this.mode.mImg = this.img
      this.mode.mTooltip = this.label
      this.$emit('custom-event', this);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variable";
.circle{
    ::v-deep.el-input--small .el-input__inner{
        border-radius: 30px!important;
    }
}
.mode-select-item {
  padding: 4px 6px;
  width: 80px;
  height: 40px;
  border: 1px solid #dcdee0;
  /*no*/
  border-radius: 0;
  border-color: #ebedf0;
  font-size: 12px;
  /*no*/
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: $color-theme;
    border-color: $color-theme;
    background-color: #e0edff;

    i {
      color: $color-theme;
    }
  }

  i {
    color: #979797;
  }
}

.mode-select-item-active {
  color: $color-theme;
  border-color: $color-theme;
  background-color: #e0edff;

  i {
    color: $color-theme;
  }
}
</style>
